var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEmail(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 10,
    viewBox: "0 0 15 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Email",
    d: "M14.7158 3.30208C14.8301 3.22135 15 3.29688 15 3.42448V8.75C15 9.4401 14.3701 10 13.5938 10H1.40625C0.629883 10 0 9.4401 0 8.75V3.42708C0 3.29688 0.166992 3.22396 0.28418 3.30469C0.94043 3.75781 1.81055 4.33333 4.79883 6.26302C5.41699 6.66406 6.45996 7.50781 7.5 7.5026C8.5459 7.51042 9.60938 6.64844 10.2041 6.26302C13.1924 4.33333 14.0596 3.75521 14.7158 3.30208ZM7.5 6.66667C8.17969 6.67708 9.1582 5.90625 9.65039 5.58854C13.5381 3.08073 13.834 2.86198 14.7305 2.23698C14.9004 2.11979 15 1.9375 15 1.74479V1.25C15 0.559896 14.3701 0 13.5938 0H1.40625C0.629883 0 0 0.559896 0 1.25V1.74479C0 1.9375 0.0996094 2.11719 0.269531 2.23698C1.16602 2.85937 1.46191 3.08073 5.34961 5.58854C5.8418 5.90625 6.82031 6.67708 7.5 6.66667Z",
    fill: "#808282"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmail);
export default __webpack_public_path__ + "static/media/Email.c8034f0cff6d40779aa00e9b4e483e57.svg";
export { ForwardRef as ReactComponent };